var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeSeven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 181,
    viewBox: "0 0 181 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.549 155.923H41.4365V159.955H139.549V155.923Z",
    fill: "#26C6DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2814 126.354H89.1021V153.52H93.2814V126.354Z",
    fill: "#26C6DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5517 163.97H82.8342C80.5355 163.97 78.6548 162.089 78.6548 159.79V155.611C78.6548 153.312 80.5355 151.432 82.8342 151.432H99.5517C101.85 151.432 103.731 153.312 103.731 155.611V159.79C103.731 162.089 101.85 163.97 99.5517 163.97Z",
    fill: "#F9A825"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.682 45.9362C129.2 28.9244 111.073 17.4902 90.1568 17.4902C59.4798 17.4902 34.3804 42.5896 34.3804 73.2667C19.0419 73.2667 6.49219 85.8163 6.49219 101.155C6.49219 116.493 19.0419 129.043 34.3804 129.043H131.989C155.136 129.043 173.821 110.358 173.821 87.2108C173.821 66.8524 158.762 49.2828 138.682 45.9362Z",
    fill: "#BBDEFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3804 73.2666C43.0257 73.2666 51.1133 77.171 56.4121 84.143L51.9499 87.4896C47.7667 81.912 44.4201 75.2188 34.3804 73.2666Z",
    fill: "#90CAF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.683 45.9346C143.145 54.0222 145.934 63.2253 145.934 73.265H140.356C140.356 63.783 141.193 53.4644 138.683 45.9346Z",
    fill: "#90CAF9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSeven);
export default __webpack_public_path__ + "static/media/HomeSeven.b811c0603b02f0deb75ab35d0098b416.svg";
export { ForwardRef as ReactComponent };